import { Component, OnInit, Input, Output } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { AuthenticationService } from '../../services/core/authentication.service';
import { ConfigService } from '../../services/core/config.service';
import { ApiConnectionService } from '../../services/core/api-connection.service';

import { AppService } from 'src/app/services/app.service';

@Component({
	selector: 'app-modal-password-recovery',
	templateUrl: './modal-password-recovery.component.html',
	styleUrls: ['./modal-password-recovery.component.scss']
})
export class ModalPasswordRecoveryComponent implements OnInit {
	@Input() public message;
	@Output() passEntry: EventEmitter<any> = new EventEmitter();
	public email = '';
	public password = '';
	error = false;
	errors: any = [];
	emailValid = false;
	passwordValid = false;
	errorEmailRequired = false;
	errorInvalidEmail = false;
	errorInvalidEmailTld = false;
	errorPasswordRequired = false;
	errorInvalidPassword = false;
	errormessage = false;
	successmessage = false;
	submitted = false;
	currentUser;
	salesWebsite = '';
	allowedTld: any;

	constructor(
		public activeModal: NgbActiveModal,
		public api: ApiConnectionService,
		private authenticateService: AuthenticationService,
		private configService: ConfigService,
		private ngxLoader: NgxUiLoaderService,
		private router: Router,
		private appService: AppService
	) {
		let self = this;

		this.salesWebsite = configService.get('sales_website');

		self.authenticateService.data.subscribe(data => {
			if (Object.keys(data).length) {
				self.currentUser = data;
			} else {
				self.currentUser = false;
			}
		});
		this.allowedTld = configService.get('registration_allowed_extension');

		this.email = this.appService.pageDocumentObject.tempEmail;
		if(this.email != '') {
			this.save();
		}
	}

	ngOnInit() {

	}

	resetValidation() {
		this.error = false;
		this.errorEmailRequired = false;
		this.errorInvalidEmail = false;
		this.errorInvalidEmailTld = false;
		this.emailValid = false;
	}

	save() {
		this.resetValidation();

		if (this.email.length < 3) {
			this.errorEmailRequired = true;
			return;
		} else if (this.validateEmail(this.email) === false) {
			this.errorInvalidEmail = true;
			return;
		} else if (this.validateTld(this.email) === false) {
			this.errorInvalidEmailTld = true;
			return;
		}

		let self = this;

		self.errors = [];
		self.successmessage = false;
		self.errormessage = false;

		this.ngxLoader.start();
		this.api.save('users/passwordRecovery', { email: self.email }).then((response) => {
			self.ngxLoader.stop();
			self.successmessage = true;
			self.submitted = true;
		}).catch(function (response) {
			self.ngxLoader.stop();
			self.errormessage = true;
			self.submitted = true;
			for (let error in response['error']['errors']) {
				self.errors[error] = response['error']['errors'][error];
			}
		});
	}

	close() {
		this.activeModal.close(false);
	}

	checkEmail(event) {
		this.errorEmailRequired = false;
		this.errorInvalidEmail = false;
		this.errorInvalidEmailTld = false;

		if (this.email.length < 3) {
			this.errorEmailRequired = true;
		} else if (this.validateEmail(this.email) === false) {
			this.errorInvalidEmail = true;
		} else if (this.validateTld(this.email) === false) {
			this.errorInvalidEmailTld = true;
		} else {
			this.emailValid = true;
		}
	}

	validateTld(email) {
		let emailPieces = email.split('.');
		let tld = emailPieces.pop();
		tld = tld.toLowerCase();

		let tldAllowed = false;
		for (let x = 0; x < this.allowedTld.length; x++) {
			if (this.allowedTld[x] == tld) {
				tldAllowed = true;
			}
		}

		return tldAllowed;
	}

	validateEmail(email) {
		const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}
}
